import { useCallback } from 'react';

import { useMutation } from '@tanstack/react-query';

import { useUiContext } from '../context/UiContext';

export default function useMutationWithConfirmation({
  refetch,
  mutationFn,
  successMessage,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmationMessage,
  dialogType,
}) {
  const { showApiErrorToast, showSuccessToast, showDialogModal } =
    useUiContext();

  const { mutate, isPending } = useMutation({
    mutationFn,
    onSuccess: () => {
      showSuccessToast(successMessage);
      refetch?.();
    },
    onError: (error) => {
      showApiErrorToast(error);
    },
  });

  const confirm = useCallback(() => {
    showDialogModal({
      title: 'Confirmation',
      message: confirmationMessage,
      type: dialogType,
      onConfirm: mutate,
      confirmButtonLabel,
      cancelButtonLabel,
    });
  }, [
    cancelButtonLabel,
    confirmButtonLabel,
    confirmationMessage,
    dialogType,
    mutate,
    showDialogModal,
  ]);

  return {
    mutate,
    isPending,
    confirm,
  };
}
